window.onscroll  = ()=>{
    let onboardings = document.querySelectorAll('.onboarding');
    for (let i = 0; i<onboardings.length; i++) {
        if (onboardings[i].getBoundingClientRect().y < window.innerHeight * 0.6) {
            if (onboardings[i].className.indexOf('vis') < 0){
                onboardings[i].className += ' vis';
            }
        }
        else {
            if (onboardings[i].className.indexOf('vis') >= 0){
                onboardings[i].className = onboardings[i].className.replace(' vis', '');
            }
        }
    }
}